import { render, staticRenderFns } from "./Threads.vue?vue&type=template&id=1cf17d39&scoped=true&"
import script from "./Threads.vue?vue&type=script&lang=js&"
export * from "./Threads.vue?vue&type=script&lang=js&"
import style0 from "./Threads.vue?vue&type=style&index=0&id=1cf17d39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf17d39",
  null
  
)

export default component.exports